import * as React from "react";
import Select from "react-select";
import { LanguageInfo } from "../Shared";

interface ILanguagePickerProps {
	options: LanguageInfo[];
	value: string;
	onChange: (option: LanguageInfo) => void;
	isBranding?: boolean;
}

export class LanguagePicker extends React.Component<ILanguagePickerProps, {}> {
	onLanguageSelect = (option: LanguageOption) => {
		if (this.props.isBranding) {
			this.props.onChange(
				this.props.options.filter((o) => o.name == option.value)[0]
			);
		} else {
			this.props.onChange(
				this.props.options.filter((o) => o.name == option.value)[0]
			);
		}
	};

	valueRenderer = (option: LanguageOption) => {
		return (
			<div className="select-value">
				<div
					title={option.label}
					className={"flag flag-" + option.region.toLowerCase()}
				/>
				<span className="select-value-label">{option.label}</span>
			</div>
		);
	};

	get value() {
		if (this.props.isBranding) {
			return this.options.filter(
				(o) => o.value.split("-")[0] === this.props.value
			)[0];
		}
		return this.options.filter((o) => o.value === this.props.value)[0];
	}

	get options() {
		return this.props.options.map((l) => {
			let option = new LanguageOption();
			option.value = l.name;
			option.label = l.caption;
			option.region = l.region;
			return option;
		});
	}

	render() {
		return (
			<Select
				value={this.value}
				options={this.options}
				formatOptionLabel={this.valueRenderer}
				onChange={this.onLanguageSelect}
				placeholder=""
				isSearchable={false}
				className="language-picker"
			/>
		);
	}
}

class LanguageOption {
	value: string;
	label: string;
	region: string;
}

//class OptionComponent extends React.Component<OptionComponentProps<string>, {}> {

//	onClick = (event: React.MouseEvent<any>) => {
//		this.props.onSelect(this.props.option, event);
//	}

//	render() {
//		return <div className={this.props.className} onClick={this.onClick}>
//			<i><img title={this.props.option.label} src={"../../images/flags/" + this.props.option.region + ".png"} /></i>
//			{this.props.children}
//		</div>
//	}
//}
